import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom"; // Update the import statement
import Header from "./Component/Mainpage.js/Header";
import Home from "./Component/Pages.js/Home";
import Footer from "./Component/Mainpage.js/Footer";
import Contact from "./Component/Pages.js/Contact";
import About from "./Component/Pages.js/About";
import Service from "./Component/Pages.js/Service";
import Career from "./Component/Pages.js/Career";
import Ourproject from "./Component/Pages.js/Ourproject";
import BookingModal from "./Component/Pages.js/BookingModal";
import BookNow from "./Component/Pages.js/BookNow";
import Authform from "./Component/Pages.js/Authform";

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Authform" element={<Authform />} />
        <Route path="/About" element={<About />} />
        <Route path="/Service" element={<Service />} />
        <Route path="/Career" element={<Career />} />
        <Route path="/Contact" element={<Contact />} />
        <Route path="/Ourproject" element={<Ourproject />} />
        <Route path="/booking" element={<BookingModal />} />
        <Route path="/book" element={<BookNow />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
